import React from 'react';
import { useParams } from 'react-router-dom';

const HEADSHOT_URL = 'https://alakaialoha.com/images/email-signatures/Kealani_headshot_for_signature.JPG';
const LOGO_URL = 'https://alakaialoha.com/images/email-signatures/Horizontal%20-%20color.png';
const SIGNATURES = {
  '': {
    name: 'Kealani',
    title: 'Kauai Travel Concierge',
    brandDisplay: "Alaka'i Aloha",
    websiteDisplay: 'https://alakaialoha.com',
    websiteHref: 'https://alakaialoha.com',
    phoneDisplay: '(808) 212-3370',
    phoneHref: 'sms:+18082123370',
    headshotUrl: HEADSHOT_URL,
    logoUrl: LOGO_URL,
  },
  kealani: {
    name: 'Kealani',
    title: 'Kauai Travel Concierge',
    brandDisplay: "Alaka'i Aloha",
    websiteDisplay: 'https://alakaialoha.com',
    websiteHref: 'https://alakaialoha.com',
    phoneDisplay: '(808) 212-3370',
    phoneHref: 'sms:+18082123370',
    headshotUrl: HEADSHOT_URL,
    logoUrl: LOGO_URL,
  },
  'kealani-signature': {
    name: 'Kealani',
    title: 'Kauai Travel Concierge',
    brandDisplay: "Alaka'i Aloha",
    websiteDisplay: 'https://alakaialoha.com',
    websiteHref: 'https://alakaialoha.com',
    phoneDisplay: '(808) 212-3370',
    phoneHref: 'sms:+18082123370',
    headshotUrl: HEADSHOT_URL,
    logoUrl: LOGO_URL,
  },
};

const EmailSignaturePage = () => {
  const { '*': wildcardPath = '' } = useParams();
  const normalizedPath = wildcardPath.replace(/^\/+|\/+$/g, '').toLowerCase();
  const signature = SIGNATURES[normalizedPath] || SIGNATURES[''];

  return (
    <main
      style={{
        minHeight: '100vh',
        backgroundColor: '#f4f6f8',
        padding: '32px 20px',
        fontFamily: 'Arial, Helvetica, sans-serif',
        color: '#111111',
      }}
    >
      <div
        style={{
          maxWidth: '860px',
          margin: '0 auto',
        }}
      >
        <h1 style={{ fontSize: '24px', margin: '0 0 10px 0' }}>Alaka&apos;i Aloha Email Signature</h1>
        <p style={{ fontSize: '14px', margin: '0 0 20px 0' }}>
          Highlight the signature below, copy it, and paste directly into Gmail Signature settings.
        </p>

        <div
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #d9dde3',
            borderRadius: '10px',
            padding: '20px',
            overflowX: 'auto',
          }}
        >
          <table
            cellPadding="0"
            cellSpacing="0"
            border="0"
            style={{
              width: '320px',
              borderCollapse: 'collapse',
              fontFamily: 'Arial,Helvetica,sans-serif',
              lineHeight: '1.25',
            }}
          >
            <tbody>
              <tr>
                <td style={{ padding: '0 12px 0 0', verticalAlign: 'top', width: '122px' }}>
                  <img
                    src={signature.headshotUrl}
                    alt={signature.name}
                    width="122"
                    height="138"
                    style={{
                      display: 'block',
                      width: '122px',
                      height: '138px',
                      objectFit: 'cover',
                      objectPosition: '50% 24%',
                    }}
                  />
                </td>

                <td style={{ padding: '2px 0 0 0', verticalAlign: 'top', whiteSpace: 'nowrap', width: '186px' }}>
                  <div style={{ fontSize: '16px', fontWeight: 700, color: '#111111', margin: 0, padding: 0 }}>
                    {signature.name}
                  </div>
                  <div style={{ fontSize: '13px', color: '#111111', margin: '4px 0 0 0', padding: 0 }}>
                    {signature.title}
                  </div>
                  <div style={{ fontSize: '13px', color: '#111111', margin: '6px 0 0 0', padding: 0 }}>
                    <a href={signature.websiteHref} style={{ color: '#111111', textDecoration: 'none' }}>
                      {signature.brandDisplay}
                    </a>
                  </div>
                  <div style={{ fontSize: '13px', color: '#111111', margin: '4px 0 0 0', padding: 0 }}>
                    <a href={signature.websiteHref} style={{ color: '#111111', textDecoration: 'none' }}>
                      {signature.websiteDisplay}
                    </a>
                  </div>
                  <div style={{ fontSize: '13px', color: '#111111', margin: '4px 0 0 0', padding: 0 }}>
                    <a href={signature.phoneHref} style={{ color: '#111111', textDecoration: 'none' }}>
                      {signature.phoneDisplay}
                    </a>
                  </div>
                </td>
              </tr>

              <tr>
                <td colSpan="2" style={{ padding: '12px 0 0 0', verticalAlign: 'middle' }}>
                  <a href={signature.websiteHref} style={{ textDecoration: 'none' }}>
                    <img
                      src={signature.logoUrl}
                      alt="Alaka'i Aloha"
                      width="320"
                      style={{ display: 'block', width: '320px', height: 'auto' }}
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
};

export default EmailSignaturePage;
